// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1RcR-","rootCenter":"LoadMoreObserver_rootCenter__3vT2q","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3G_3u"};